import './manager.component.less'

class ManagerController {
  constructor ($rootScope, $scope, $transitions, $state, ClientService, SceneService, PrimusService) {
    'ngInject'

    this.clientId = ClientService.id

    this.Scenes = SceneService.getAll()

    this.unsubscribe = SceneService.subscribe(state => {
      this.Scenes = state.Scenes
    })

    this.version = ClientService.version

    this.State = $state

    // Menu is initially closed
    this.isMenuCollapsed = true
    this.isDropdownOpen = false

    // Connection status tracking
    this.connectionStatus = PrimusService.getConnectionStatus()
    this._unsubscribeConnectionStatus = PrimusService.onConnectionStatusChange(status => {
      this.connectionStatus = status
    })

    $transitions.onSuccess({}, () => {
      this.isMenuCollapsed = true
      this.isDropdownOpen = false
    })

    // Stats for any uploads in progress
    this.uploadStats = {}
    this._uploadStatsListener = $rootScope.$on('asset-upload-service:stats', ($event, stats) => {
      this.uploadStats = stats
    })

    $scope.$on('$destroy', () => {
      this.unsubscribe()
      this._uploadStatsListener()
      this._unsubscribeConnectionStatus()
    })

    this.isActive = (sceneId) => {
      return (
        $state.is('manager.scene') && parseInt($state.params.id) === sceneId
      )
    }

    this.toggleDropdown = ($event) => {
      $event.preventDefault()
      $event.stopPropagation()
      this.isDropdownOpen = !this.isDropdownOpen
    }

    // Helper methods for connection status display
    this.getConnectionStatusIcon = () => {
      // Simplify to just online/offline for user
      const isOnline = this.connectionStatus === 'connected'
      return isOnline ? 'fa-circle text-success' : 'fa-circle text-danger'
    }

    this.getConnectionStatusTitle = () => {
      // Still show detailed status in tooltip
      switch (this.connectionStatus) {
        case 'connected': return 'Online - Connected to server'
        case 'connecting': return 'Connecting - Attempting to reconnect'
        case 'disconnected': return 'Offline - No connection to server'
        case 'mock': return 'Offline Mode - Using mock connection'
        default: return 'Unknown connection status'
      }
    }
  }
}

export default {
  controller: ManagerController,
  template: require('./manager.component.html').default
}
